import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <a href="https://github.com/imgly/vesdk-android-demo" target="_blank" rel="noopener nofollow noreferrer">
  demo repository
    </a>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      